import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper/swiper-bundle';

// document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", function(){

  const mySwiper = new Swiper('.j-fvSlider', {
    loop: true,
    speed: 2000,
    autoplay: {
      delay: 2000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
  });
// setTimeout(() => {
// const mySwiper = new Swiper('.j-fvSlider', {
//   speed: 1000,
//   spaceBetween: 0,
//   effect: 'fade',
//   fadeEffect: {
//     crossFade: true
//   },
//   fadeEffect: { crossFade: true },
//   loop: true,
//   allowTouchMove: false,
//   autoplay: {
//     delay: 3500,
//     disableOnInteraction: false,
//   },
// });
// }, 20);

// =======================================
// 初期スライドをロード時にフェード＋ズーム
// =======================================
// const activePic = document.querySelector('.j-fvSlider .swiper-slide-active picture');
// if (activePic) {
//   // 少し遅延させてクラス付与 → transition が確実に発火
//   setTimeout(() => {
//     activePic.classList.add('is-zoom');
//     console.log(activePic);

//   }, 2000);
// }
// mySwiper.on('init', () => {
// });
// mySwiper.init();

// =======================================
// スライドが切り替わるたびにフェード＋ズーム
// =======================================
// mySwiper.on('slideChangeTransitionStart', () => {
//   // 全ての picture からクラスを削除
//   document.querySelectorAll('.j-fvSlider picture').forEach(pic => pic.classList.remove('is-zoom'));

//   // 現在の active スライドにクラスを付与
//   const activePic = mySwiper.slides[mySwiper.activeIndex].querySelector('picture');
//   if (activePic) {
//     setTimeout(() => {
//       activePic.classList.add('is-zoom');
//     }, 50);
//   }
// });




  const personsSlider = new Swiper(".j-personsSlider", {
    speed: 1000,
    spaceBetween: 16,
    slidesPerView: 1.4,
    loop: true,
    centeredSlides: true,
    // pagination: {
    // 	el: ".swiper-pagination",
    // 	clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },

      breakpoints: {
        768: {
          spaceBetween: 80,
          slidesPerView: 2.5,
      },
      // on: {
      //     init: function () {
      //         setNavButtonPosition($slider);
      //     },
      //     resize: function () {
      //         setNavButtonPosition($slider);
      //     }
      // }
    }
  });

  // gsap.registerPlugin(ScrollTrigger);

  // const fv = document.querySelector(".p-newgrads_fv");
  // const fvPin = document.querySelector(".j-newgrads_fv_pin");

  // gsap.timeline({
  //   scrollTrigger: {
  //     trigger: fv,
  //     start: "top top",
  //     end: "+=100%",
  //     scrub: true,
  //     pin: true,
  //     pinSpacing: false, // ★重要
  //   }
  // })
  // .to(fv, {
  //   maskPosition: "right top",
  //   ease: "none"
  // });

  gsap.registerPlugin(ScrollTrigger);

  const fv = document.querySelector(".p-newgrads_fv");
  const fvPin = document.querySelector(".j-newgrads_fv_pin");
  const fvTriger = document.querySelector(".j-newgrads_fv_trigerend");
  const fvWrap = document.querySelector(".j-newgrads_fv_wrap");
  // let nextanimation = document.querySelector(".p-newgrads_fv");
  ScrollTrigger.create({
    trigger: fvTriger,
    start: "top top",
    end: "bottom top",
    // end: "+=50%",
    pin: fvPin,
    // markers: true,
  });
  gsap.to(fvWrap, {
    maskImage: "linear-gradient(225deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 0%, transparent 0%, transparent 100%)",
    duration: 1.0,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: fvTriger,
      start: "+=20% top",
      scrub: false,
      toggleActions: "play none none reverse",
      // markers: true,
      onEnter: () => {
        setTimeout(() => {
          document.querySelector(".p-newgrads_persons_head_ttl").classList.add("active");
          document.querySelector(".p-newgrads_persons_head_subttl").classList.add("active");
          document.querySelector(".p-newgrads_persons_slider").classList.add("active");
          fv.classList.add("u-pointer-none");
        }, 1000);
      },
      onLeaveBack: () => {
        setTimeout(() => {
          fv.classList.remove("u-pointer-none");
        }, 1000);
      }
    },

  });

  const persons = document.querySelector(".p-newgrads_persons");
  const personsPin = document.querySelector(".j-newgrads_persons_pin");
  const personsTriger = document.querySelector(".j-newgrads_persons_trigerend");
  const personsWrap = document.querySelector(".j-newgrads_persons_wrap");
  ScrollTrigger.create({
    trigger: personsTriger,
    start: "top top",
    // end: "+=150%",
    // end: "bottom top",
    pin: personsPin,
    // markers: true,
  });
  gsap.to(personsWrap, {
    clipPath: "polygon(50% 0%, 100% 0%, 100% 0%, 50% 0%, 50% 100%, 0 100%, 0% 100%, 50% 100%)",
    duration: 0.5,
    ease: "power2.inOut",
    scrollTrigger: {
      trigger: personsTriger,
      // start: "+=100%",
      start: "+=50% top",
      scrub: false,
      toggleActions: "play none none reverse",
      // markers: true,
      onEnter: () => {
        setTimeout(() => {
          document.querySelector(".p-newgrads_story_head").classList.add("active");
          document.querySelector(".p-newgrads_story_txtarea").classList.add("active");
          persons.classList.add("u-pointer-none");
        }, 500);
      },
      onLeaveBack: () => {
        setTimeout(() => {
          persons.classList.remove("u-pointer-none");
        }, 500);
      }
    }
  });

  const story = document.querySelector(".p-newgrads_story");
  const storyPin = document.querySelector(".j-newgrads_story_pin");
  const storyTriger = document.querySelector(".j-newgrads_story_trigerend");
  const storyWrap = document.querySelector(".j-newgrads_story_wrap");
  ScrollTrigger.create({
    trigger: storyTriger,
    start: "top top",
    end: "bottom top",
    pin: storyPin,
    // markers: true,
  });

});




const isMobile = window.matchMedia("(max-width: 768px)").matches;

if(!isMobile) {
  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      location.reload();
    }, 500); // ← 0.5秒後にリロード
  });
}